import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconAlert = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_alert_circled_filled"
      data-name="UI icon/alert_circled/filled"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        id="Subtract"
        d="M11,22A11,11,0,1,1,22,11,11.012,11.012,0,0,1,11,22Zm0-6.6a1.1,1.1,0,1,0,1.1,1.1A1.1,1.1,0,0,0,11,15.4Zm0-9.9A1.1,1.1,0,0,0,9.9,6.6v5.5a1.1,1.1,0,0,0,2.2,0V6.6A1.1,1.1,0,0,0,11,5.5Z"
        fill={color}
      />
    </svg>
  );
};

export default IconAlert;
